<template>
  <article class="chart-wrapper tick-container">
    <section class="header-option-container">
      <div class="basic-wrapper">
        <slot name="basic-header-slot"></slot>
        <div class="radio-wrapper"></div>
      </div>

      <div class="advance-wrapper">
        <div class="period-list">
          <div class="radio-wrapper">
            <div class="radio-list" v-if="!isDashboard">
              <UiRadioBtn :items="marketRadioList" @onChange="radioHandler" />
              <!-- radio btn componenet ( none , bull market , ... ) -->
            </div>
          </div>
          <div class="btn-list">
            <UiBtn
              :isClickActive="false"
              :btnItems="periodBtnList"
              @btnClick="periodBtnClick"
              class="btn-list"
            />
            <!-- period Btn => 차트 보여주는 기간 표시 -->
          </div>
        </div>
        <!-- 우측 상단 체크한 체크박스 라벨 표시  -->
        <div class="chart-label">
          <div
            v-show="chkStatus('pink')"
            @click="toggleVisible('pink', pinkLine)"
          >
            <img
              src="@/assets/images/icons/chart/label-pink.png"
              v-if="toggleStatus['pink']"
            />
            <img src="@/assets/images/icons/chart/label-inactive.png" v-else />
            <p :style="{ color: toggleStatus['pink'] ? '#fff' : '#7A7A7A' }">
              Kibot Line
            </p>
          </div>
          <div v-show="chkStatus('ma3')" @click="toggleVisible('ma1', MA1Line)">
            <img
              src="@/assets/images/icons/chart/label-ma1.png"
              v-if="toggleStatus['ma1']"
            />
            <img src="@/assets/images/icons/chart/label-inactive.png" v-else />
            <p :style="{ color: toggleStatus['ma1'] ? '#fff' : '#7A7A7A' }">
              ma1
            </p>
          </div>
          <div v-show="chkStatus('ma3')" @click="toggleVisible('ma2', MA2Line)">
            <img
              src="@/assets/images/icons/chart/label-ma2.png"
              v-if="toggleStatus['ma2']"
            />
            <img src="@/assets/images/icons/chart/label-inactive.png" v-else />
            <p :style="{ color: toggleStatus['ma2'] ? '#fff' : '#7A7A7A' }">
              ma2
            </p>
          </div>
          <div v-show="chkStatus('ma3')" @click="toggleVisible('ma3', MA3Line)">
            <img
              src="@/assets/images/icons/chart/label-ma3.png"
              v-if="toggleStatus['ma3']"
            />
            <img src="@/assets/images/icons/chart/label-inactive.png" v-else />
            <p :style="{ color: toggleStatus['ma3'] ? '#fff' : '#7A7A7A' }">
              ma3
            </p>
          </div>
          <div
            v-show="chkStatus('bb')"
            @click="toggleVisible('upper', UpperLine)"
          >
            <img
              src="@/assets/images/icons/chart/label-upper.png"
              v-if="toggleStatus['upper']"
            />
            <img src="@/assets/images/icons/chart/label-inactive.png" v-else />
            <p :style="{ color: toggleStatus['upper'] ? '#fff' : '#7A7A7A' }">
              Upper
            </p>
          </div>
          <div
            v-show="chkStatus('bb')"
            @click="toggleVisible('lower', LowerLine)"
          >
            <img
              src="@/assets/images/icons/chart/label-lower.png"
              v-if="toggleStatus['lower']"
            />
            <img src="@/assets/images/icons/chart/label-inactive.png" v-else />
            <p :style="{ color: toggleStatus['lower'] ? '#fff' : '#7A7A7A' }">
              Lower
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="tick-chart-wrap">
      <Loading v-show="!isFetch" :msg="errorRef" :isError="!!errorRef" />
      <!-- 차트 컨테이너 -->
      <div
        v-show="isFetch"
        class="meta-chart"
        ref="chartContainer"
        stlye="height:100%"
      ></div>
    </section>
    <section class="option-container" v-if="!isDashboard">
      <div class="checkbox-wrapper">
        <span class="checkbox-label highlight highlight__400">
          <img src="@/assets/images/pages/index/whiteflame.svg" alt="" />Easy
          Draw</span
        >
        <div class="checkbox-list">
          <UiCheckBox :items="checkList" @onChange="checkboxHandler" />
          <!-- 체크박스 -->
        </div>
      </div>
    </section>
  </article>
</template>

<script setup>
import { getCssVariableValue } from "@/utils/utils";
import {
  onMounted,
  onUnmounted,
  ref,
  defineProps,
  defineEmits,
  watch,
} from "vue";
import { createChart } from "lightweight-charts";
import axios from "axios";
import { getChartData, getSr } from "@/api/chart/metaChartAPI";
import UiRadioBtn from "@/components/ui/RadioBtn.vue";
import UiBtn from "@/components/ui/Button.vue";
import UiCheckBox from "@/components/ui/CheckBox.vue";
import Loading from "@/components/common/Loading.vue";
const props = defineProps({
  ticker: String,
  isDashboard: Boolean,
});
const emit = defineEmits(["mounted"]);
if (props.isDashboard) {
  checkList.value.forEach((item) => {
    item.checked = false;
  });
}
const ticker = ref(props.ticker);
let candleLoad = false;
let candleHeiLoad = false;
let isFetch = ref(false);
const errorRef = ref("");

watch(
  () => props.ticker,
  async (val) => {
    console.log("ticker", val);
    ticker.value = val;
    // console.log('new ticker',ticker.value);
    candleLoad = false;
    candleHeiLoad = false;

    seriesData.forEach((obj) => {
      obj.initLoad = false;
    });
    priceLineData.find((ob) => ob.id == "sr").initLoad = false;
    loadPriceLineData(val, "sr");
    checkList.value.forEach((obj) => {
      if (obj.id != "pink") {
        obj.checked = false;
        loadSeriesData(val, obj.id);
      } else {
        obj.checked = true;
      }
    });
    marketRadioList.forEach((obj) => (obj.checked = false));
    await getCandleData(candleStickSeries, pinkLine, uoSeries, "candle");
    await getSignalMarkers(candleStickSeries);
  }
);
let chart;
let chartContainer = ref();
let localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
let chartOptions = ref({
  trackingMode: {
    exitMode: 1,
  },
  kineticScroll: {
    mouse: false,
  },
  autoSize: true,
  height: "100%",
  leftPriceScale: {
    borderVisible: true,
    visible: false,
    scaleMargins: {
      //가격축 간격
      top: 0.7,
      bottom: 0.1,
    },
    ticksVisible: true,
  },
  // overlayPriceScale:{
  //     position:'left',
  //     borderVisible: false,
  //     visible:false,
  // },
  rightPriceScale: {
    visible: true,
    borderColor: "transparent",
    ticksVisible: true,
    textColor: getCssVariableValue("--chart-xy-font-color"),
  },
  layout: {
    background: { color: "transparent" },
    textColor: getCssVariableValue("--chart-x-font-color"),
    fontFamily: "Pretendard",
  },
  grid: {
    vertLines: {
      color: "transparent",
    },
    horzLines: {
      color: "#454951",
      lineWidth: 1,
    },
  },
  timeScale: {
    barSpacing: 11,
    timeVisible: true,
    borderColor: "#454951",
    textColor: getCssVariableValue("--chart-x-font-color"),
    tickMarkFormatter(time) {
      var convertTime = new Date(time * 1000);
      let optionsT = {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: localTimezone,
      };
      let localTime = convertTime
        .toLocaleString("en-US", optionsT)
        .replace(",", "");
      localTime = localTime.replace(/\//g, "-");
      return localTime;
    },
  },
  crosshair: {
    mode: 0,
  },
  localization: {
    timeFormatter(originalTime, timeZone) {
      const zonedDate = new Date(
        new Date(originalTime * 1000).toLocaleString("en-US", { timeZone })
      );
      const year = zonedDate.getFullYear();
      const month = (zonedDate.getMonth() + 1).toString().padStart(2, "0");
      const day = zonedDate.getDate().toString().padStart(2, "0");
      const hours = zonedDate.getHours().toString().padStart(2, "0");
      const minutes = zonedDate.getMinutes().toString().padStart(2, "0");
      let formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formattedDateTime;
    },
  },
});
// let selectedInterval = ref('1h');
let url = "https://chart-api.risingx.io";

let candleStickSeries,
  pinkLine,
  uoSeries,
  MA1Line,
  MA2Line,
  MA3Line,
  UpperLine,
  LowerLine;
// candle, heikin candle
let candleArray = [],
  pinkArray = [],
  candleHeiArray = [],
  pinkHeiArray = [],
  uoArray = [],
  uoHeiArray = [];
// 3ma , bb
let MA1Data = [],
  MA2Data = [],
  MA3Data = [],
  UpperData = [],
  LowerData = [];
// heikin 3ma , bb
let MA1HeiData = [],
  MA2HeiData = [],
  MA3HeiData = [],
  UpperHeiData = [],
  LowerHeiData = [];
// sr (price line)
let H4Wlines = "",
  H3Wlines = "",
  H2Wlines = "",
  H1Wlines = "",
  H2Dlines = "",
  H1Dlines = "";
let L4Wlines = "",
  L3Wlines = "",
  L2Wlines = "",
  L1Wlines = "",
  L2Dlines = "",
  L1Dlines = "";
let H4W, H3W, H2W, H1W, H2D, H1D, L4W, L3W, L2W, L1W, L2D, L1D;
// signal , tooltip
let signalMarkers = [];
let tooltipData;
// checkbox
let seriesData = [
  {
    id: "ma3",
    url: "candle-ma",
    series: [MA1Line, MA2Line, MA3Line],
    data: [
      { array: MA1Data, name: "ma1" },
      { array: MA2Data, name: "ma2" },
      { array: MA3Data, name: "ma3" },
    ],
    initLoad: false,
  },
  {
    id: "bb",
    url: "candle-bb",
    series: [UpperLine, LowerLine],
    data: [
      { array: UpperData, name: "upper" },
      { array: LowerData, name: "lower" },
    ],
    initLoad: false,
  },
  {
    id: "ma3",
    url: "heikin-ma",
    series: [MA1Line, MA2Line, MA3Line],
    data: [
      { array: MA1HeiData, name: "ma1" },
      { array: MA2HeiData, name: "ma2" },
      { array: MA3HeiData, name: "ma3" },
    ],
    initLoad: false,
  },
  {
    id: "bb",
    url: "heikin-bb",
    series: [UpperLine, LowerLine],
    data: [
      { array: UpperHeiData, name: "upper" },
      { array: LowerHeiData, name: "lower" },
    ],
    initLoad: false,
  },
];

let priceLines = [];
let priceLineData = [
  {
    id: "sr",
    url: "sr",
    series: [
      H4Wlines,
      H3Wlines,
      H2Wlines,
      H1Wlines,
      H2Dlines,
      H1Dlines,
      L4Wlines,
      L3Wlines,
      L2Wlines,
      L1Wlines,
      L2Dlines,
      L1Dlines,
    ],
    data: [
      { array: H4W, name: "h_4w" },
      { array: H3W, name: "h_3w" },
      { array: H2W, name: "h_2w" },
      { array: H1W, name: "h_1w" },
      { array: H2D, name: "h_2d" },
      { array: H1D, name: "h_1d" },
      { array: L4W, name: "l_4w" },
      { array: L3W, name: "l_3w" },
      { array: L2W, name: "l_2w" },
      { array: L1W, name: "l_1w" },
      { array: L2D, name: "l_2d" },
      { array: L1D, name: "l_1d" },
    ],
    initLoad: false,
  },
];

const checkList = ref([
  // 체크박스 목록들
  {
    key: "all",
    id: "all",
    value: "All",
    checked: false,
    name: "chkOption",
    selectAll: true,
    highlight: false,
    disable: false,
  },
  {
    key: "pink",
    id: "pink",
    value: "Kibot Line",
    checked: true,
    name: "chkOption",
    disable: false,
  },
  {
    key: "hei",
    id: "hei",
    value: "Heikin-Ashi",
    checked: false,
    name: "chkOption",
    disable: false,
  },
  {
    key: "ma3",
    id: "ma3",
    value: "3MA",
    checked: false,
    name: "chkOption",
    disable: false,
  },
  {
    key: "sr",
    id: "sr",
    value: "Support & Resistance",
    checked: false,
    name: "chkOption",
    disable: false,
  },
  {
    key: "bb",
    id: "bb",
    value: "Bollinger band",
    checked: false,
    name: "chkOption",
    disable: false,
  },
]);
const chkStatus = (id) => {
  //  체크 유무
  let checkedStatus = checkList.value.find((el) => el.id === id);
  return checkedStatus.checked;
};
// ma,hei
const loadSeriesData = async (symbol, id) => {
  let seriesObj;
  seriesObj =
    chkStatus("hei") == true
      ? seriesData.filter((el) => el.url.startsWith("heikin") && el.id == id)[0]
      : seriesData.find((el) => el.id === id); // heikin 체크여부로 체크리스트에서 hei인거,아닌거 객체 가져옴
  // console.log("seriesObj", seriesObj);
  if (seriesObj != undefined) {
    const { url, series, data } = seriesObj;
    if (!seriesObj.initLoad) {
      // 초기 로드시에만 데이터 가져옴
      try {
        await getChartData(url, symbol, data);
        seriesObj.initLoad = true;
      } catch (error) {
        // console.log(error);
        return;
      }
    }
    series.forEach((lineSeries, index) => {
      // 시리즈 데이터 넣기
      if (chkStatus(id)) {
        lineSeries.setData(data[index].array);
      } else {
        lineSeries.setData([]);
      }
    });
    // console.log("seriesData", seriesData);
  }
};
const loadPriceLineData = async (symbol, id) => {
  // sr 가격선
  const priceLineObj = priceLineData.find((el) => el.id === id);
  // console.log("priceLineObj", priceLineObj);
  const { url, series, data } = priceLineObj;
  if (!priceLineObj.initLoad) {
    try {
      await getSr(url, symbol, data);
      priceLineObj.initLoad = true;
    } catch (err) {
      // console.log(err);
      return;
    }
  }
  series.forEach((priceLine, index) => {
    // 체크할때마다 원래 있던 가격선 지운다음에 다시 생성
    const existingPriceLine = priceLines.find(
      (line) => line.options().title === data[index].array.title
    );
    if (chkStatus(id)) {
      if (existingPriceLine) {
        candleStickSeries.removePriceLine(existingPriceLine);
        priceLines = priceLines.filter((line) => line !== existingPriceLine); // 배열에서 제거
      }
      priceLine = candleStickSeries.createPriceLine(data[index].array);
      priceLines.push(priceLine); // 저장
    } else {
      if (existingPriceLine) {
        candleStickSeries.removePriceLine(existingPriceLine);
        priceLines = priceLines.filter((line) => line !== existingPriceLine); // 배열에서 제거
      }
    }
  });
};
const checkboxHandler = async (res) => {
  let id = res.selected.id;
  let symbol = ticker.value;
  const isChecked = res.selected.checked;
  try {
    if (id === "pink") {
      if (isChecked) {
        if (chkStatus("hei")) {
          pinkLine.setData(pinkHeiArray);
        } else {
          pinkLine.setData(pinkArray);
        }
      } else {
        pinkLine.setData([]);
      }
    } else if (id === "sr") {
      await loadPriceLineData(symbol, "sr");
    } else if (id === "hei") {
      if (isChecked) {
        await getCandleData(
          candleStickSeries,
          pinkLine,
          uoSeries,
          "heikin-candle"
        );
        candleStickSeries.setData(candleHeiArray);
        uoSeries.setData(uoHeiArray);
        if (chkStatus("pink")) {
          pinkLine.setData(pinkHeiArray);
        }
      } else {
        await getCandleData(candleStickSeries, uoSeries, pinkLine, "candle");
        candleStickSeries.setData(candleArray);
        uoSeries.setData(uoArray);
        if (chkStatus("pink")) {
          pinkLine.setData(pinkArray);
        }
      }
      if (chkStatus("ma3")) {
        await loadSeriesData(symbol, "ma3");
      }
      if (chkStatus("bb")) {
        await loadSeriesData(symbol, "bb");
      }
    } else if (id === "all") {
      if (isChecked) {
        // 모든 체크박스 항목을 개별적으로 처리
        for (const el of checkList.value.filter((el) => !el.checked)) {
          el.checked = true;
          if (el.id === "ma3") {
            await loadSeriesData(symbol, "ma3");
          } else if (el.id === "bb") {
            await loadSeriesData(symbol, "bb");
          }
        }
        await getCandleData(
          candleStickSeries,
          pinkLine,
          uoSeries,
          "heikin-candle"
        );
        candleStickSeries.setData(candleHeiArray);
        uoSeries.setData(uoHeiArray);
        pinkLine.setData(pinkHeiArray);
        await loadPriceLineData(symbol, "sr");
      } else {
        // 모든 체크박스 항목을 개별적으로 처리
        for (const el of checkList.value) {
          el.checked = false;
        }
        await loadSeriesData(symbol, "ma3");
        await loadSeriesData(symbol, "bb");
        candleStickSeries.setData(candleArray);
        uoSeries.setData(uoArray);
        pinkLine.setData([]);
        await loadPriceLineData(symbol, "sr");
      }
    } else {
      await loadSeriesData(symbol, id);
    }

    // 'all' 체크박스 상태 업데이트
    const allChecked =
      checkList.value.filter((el) => el.checked === true).length >=
      checkList.value.length - 1;
    checkList.value.find((el) => el.id === "all").checked = allChecked;

    // console.log('isFetch.value',isFetch.value);
  } catch (error) {
    console.error("An error occurred:", error);
    return;
  }
};

let selectedRadio = ref("none");
const marketRadioList = [
  {
    key: "none",
    id: "none",
    value: "None",
    checked: true,
    name: "market_radio",
    disable: false,
  },
  {
    key: "bull",
    id: "bull",
    value: "Bull Market",
    checked: false,
    name: "market_radio",
    disable: false,
  },
  {
    key: "side",
    id: "side",
    value: "Side Ways Market",
    checked: false,
    name: "market_radio",
    disable: false,
  },
  {
    key: "bear",
    id: "bear",
    value: "Bear Market",
    checked: false,
    name: "market_radio",
    disable: false,
  },
];
const periodBtnList = ref([
  {
    key: "day",
    value: "Day",
    isActive: false,
  },
  {
    key: "week",
    value: "Last 7 Days",
    isActive: false,
  },
  {
    key: "month",
    value: "Last 30 Days",
    isActive: false,
  },
]);

const periodBtnClick = ({ key, btnItems }) => {
  if (key == "day") {
    chart.timeScale().setVisibleLogicalRange({
      from: candleArray.length - 25,
      to: candleArray.length - 1,
    });
  } else if (key == "week") {
    chart.timeScale().setVisibleLogicalRange({
      from: candleArray.length - 169,
      to: candleArray.length - 1,
    });
  } else if (key == "month") {
    chart
      .timeScale()
      .setVisibleLogicalRange({ from: 0, to: candleArray.length - 1 });
  }
};

const setRadioBaseData = async (id) => {
  await getCandleData(candleStickSeries, pinkLine, uoSeries, "heikin-candle");
  if (id === "hei") {
    candleStickSeries.setData(candleHeiArray);
    uoSeries.setData(uoHeiArray);
    checkList.value.find((el) => el.id == "hei").checked = true;
  }
  if (id === "pink") {
    pinkLine.setData(pinkArray);
    checkList.value.find((el) => el.id == "pink").checked = true;
  }
};
const radioHandler = async (res) => {
  let id = res.selected.key;
  let symbol = ticker.value;
  // console.log('id',id);
  if (id == "none") {
    if (!chkStatus("pink")) {
      await setRadioBaseData("pink");
    }
    checkList.value
      .filter((el) => el.checked === true)
      .forEach((el) => {
        if (el.id != "pink") {
          el.checked = false;
          if (el.id == "hei") {
            candleStickSeries.setData(candleArray);
            uoSeries.setData(uoArray);
          }
          loadSeriesData(symbol, "ma3");
          loadSeriesData(symbol, "bb");
          loadPriceLineData(symbol, "sr");
        }
      });
  } else if (id == "bull") {
    if (!chkStatus("pink")) {
      await setRadioBaseData("pink");
    }
    if (!chkStatus("hei")) {
      await setRadioBaseData("hei");
    }
    checkList.value.find((el) => el.id == "sr").checked = true;
    loadPriceLineData(symbol, "sr");
    checkList.value
      .filter((el) => el.checked === true)
      .forEach((el) => {
        if (el.id != "pink" && el.id != "hei" && el.id != "sr") {
          el.checked = false;
          loadSeriesData(symbol, "ma3");
          loadSeriesData(symbol, "bb");
        }
      });
  } else if (id == "side") {
    // console.log('side choose');
    if (!chkStatus("pink")) {
      await setRadioBaseData("pink");
    }
    checkList.value.find((el) => el.id == "bb").checked = true;
    loadSeriesData(symbol, "bb");
    checkList.value
      .filter((el) => el.checked === true)
      .forEach((el) => {
        if (el.id != "pink" && el.id != "bb") {
          el.checked = false;
          loadSeriesData(symbol, "ma3");
          loadPriceLineData(symbol, "sr");
        }
      });
  } else if (id == "bear") {
    // hei 제외 전체 체크해제
    if (!chkStatus("hei")) {
      await setRadioBaseData("hei");
    }
    checkList.value
      .filter((el) => el.checked === true)
      .forEach((el) => {
        if (el.id != "hei") {
          el.checked = false;
          pinkLine.setData([]);
          loadSeriesData(symbol, "ma3");
          loadSeriesData(symbol, "bb");
          loadPriceLineData(symbol, "sr");
        }
      });
  }
};

const toggleStatus = ref({
  pink: true,
  ma1: true,
  ma2: true,
  ma3: true,
  upper: true,
  lower: true,
});
//  visible true ,false
const toggleVisible = (id, series) => {
  // console.log("toggleStatus.value[id]", toggleStatus.value[id]);
  toggleStatus.value[id] = !toggleStatus.value[id];
  series.applyOptions({ visible: toggleStatus.value[id] });
  // console.log("toggleStatus.value[id]", toggleStatus.value[id]);
};
const resetToggleVisible = () => {
  pinkLine.applyOptions({ visible: true });
  seriesData.forEach((list) => {
    list.series.forEach((seriesArray) => {
      // console.log("seriesArray", seriesArray);
      seriesArray.applyOptions({ visible: true });
    });
  });
};
onMounted(async () => {
  chart = createChart(chartContainer.value, chartOptions.value);
  candleStickSeries = chart.addCandlestickSeries({
    title: "Candle",
    priceScaleId: "right",
    upColor: getCssVariableValue("--chart-candle-up"),
    downColor: getCssVariableValue("--chart-candle-down"),
    color: "#fff",
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
  });
  candleStickSeries.priceScale().applyOptions({
    autoScale: true,
    scaleMargins: {
      top: 0.1,
      bottom: 0.3,
    },
  });
  pinkLine = chart.addLineSeries({
    // title:'Goya',
    lineWidth: 2,
    priceScaleId: "right",
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
    color: getCssVariableValue("--chart-pink-line"),
  });

  uoSeries = chart.addBaselineSeries({
    title: "",
    priceScaleId: "left",
    color: "#2962FF",
    baseValue: {
      type: "price",
      price: 0,
    },
    priceLineVisible: false,
    topLineColor: getCssVariableValue("--chart-candle-down"),
    topFillColor1: "rgba(255, 70, 67, 0.8)",
    topFillColor2: "rgba(255, 70, 67, 0.3)",
    bottomLineColor: getCssVariableValue("--chart-candle-up"),
    bottomFillColor1: "rgba(0, 255, 239, 0.5)",
    bottomFillColor2: "rgba(0, 255, 239, 0)",
    lineWidth: 2,
    priceFormat: {
      type: "price",
      precision: 5,
      //   minMove: 0.001,
    },
    labelVisible: false,
  });
  await getCandleData(candleStickSeries, pinkLine, uoSeries, "candle");
  await getSignalMarkers(candleStickSeries);
  MA1Line = chart.addLineSeries({
    title: "7MA",
    priceScaleId: "right",
    lineWidth: 2,
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
    color: getCssVariableValue("--chart-ma1"),
    // topFillColor : 'blue',
  });
  MA2Line = chart.addLineSeries({
    title: "20MA",
    priceScaleId: "right",
    lineWidth: 2,
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
    color: getCssVariableValue("--chart-ma2"),
    // topFillColor : 'blue',
  });
  MA3Line = chart.addLineSeries({
    title: "60MA",
    priceScaleId: "right",
    lineWidth: 2,
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
    color: getCssVariableValue("--chart-ma3"),
    // topFillColor : 'blue',
  });

  UpperLine = chart.addLineSeries({
    title: "B",
    priceScaleId: "right",
    lineWidth: 2,
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
    color: getCssVariableValue("--chart-upper"),
    // topFillColor : 'red',
  });
  LowerLine = chart.addLineSeries({
    title: "B",
    priceScaleId: "right",
    lineWidth: 2,
    priceFormat: {
      type: "price",
      precision: 5,
      minMove: 0.00001,
    },
    color: getCssVariableValue("--chart-lower"),
  });
  // seriesData.find(el => el.id === 'ma3').series = [MA1Line, MA2Line, MA3Line];
  seriesData
    .filter((el) => el.id === "ma3")
    .forEach((el) => {
      el.series = [MA1Line, MA2Line, MA3Line];
    });
  seriesData
    .filter((el) => el.id === "bb")
    .forEach((el) => {
      el.series = [UpperLine, LowerLine];
    });
  const container = chartContainer.value;
  const legend = document.createElement("div");
  legend.className = "tooltip-bg";
  legend.style = `
        position: absolute;
        display: none;
        border-style: solid;
        white-space: nowrap;
        z-index: 9999999;
        box-shadow: rgba(0, 0, 0, 0.2) 1px 2px 10px;
        transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1), visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        background-color: rgba(1, 5, 24, 0.8);
        border-width: 1px;
        border-radius: 4px;
        color: rgb(102, 102, 102);
    `;
  // legend.style.color = '#fff';
  container.appendChild(legend);
  const toolTipWidth = 140;
  let toolTipHeight = 180;
  const toolTipMargin = 15;

  var setTooltipHtml = (
    name,
    date,
    openPriceFormatted,
    highPriceFormatted,
    lowPriceFormatted,
    closePriceFormatted,
    entryStart,
    entryEnd,
    takeStart,
    takeEnd,
    stop,
    tooltipPinkVal
  ) => {
    // if( openPriceFormatted > closePriceFormatted ){ //red
    //     // legend.style.color = 'rgb(246, 70, 93)'
    // }else if(openPriceFormatted < closePriceFormatted){ //green
    //     // legend.style.color = 'rgb(14, 203, 129)'
    // }
    legend.innerHTML = "";
    let legendContent = `
            <div class="tooltip-wrap">
                <p class="time-wrap">${date}</p>
                <div class="gradient-line" style="margin-bottom:10px;" ></div>
                <section class="formatter-section">
                    <div class="formatter-wrapper" >
                        <p>Open  : ${openPriceFormatted}</p>
                        <p>Close : ${closePriceFormatted}</p>
                        <p>Low   : ${lowPriceFormatted}</p>
                        <p>High  : ${highPriceFormatted}</p>
                    </div>
                </section>
        `;

    // entryStart가 undefined가 아닐 때만 해당 섹션을 추가
    if (entryStart !== undefined) {
      legendContent += `
                <div class="gradient-line" style="margin-bottom:10px; margin-top:10px;" ></div>
                <section class="formatter-section">
                    <div class="formatter-wrapper" >
                        <p>Entry : <span class="meta-entry">${entryStart} ~ ${entryEnd}<span></span></span></p>
                        <p class="meta-take">Take  : ${takeStart} ~ ${takeEnd}</p>
                        <p class="meta-stop">Stop  : ${stop} </p>
                    </div>
                </section>
            `;
    }

    // tooltipPinkVal가 undefined가 아닐 때만 해당 섹션을 추가
    if (tooltipPinkVal !== undefined) {
      legendContent += `
                    <section class="formatter-section">
                        <div class="formatter-wrapper" >
                            <p class="kibot-line">Kibot Line : ${tooltipPinkVal}</p>
                        </div>
                    </section>
                `;
    }

    legendContent += `
                </div>
            `;

    // 최종적으로 legend.innerHTML에 내용 설정
    legend.innerHTML = legendContent;
  };

  const updateLegend = async (param) => {
    if (!candleLoad) {
      await getCandleData(candleStickSeries, pinkLine, uoSeries, "candle");
    }
    if (
      param.point === undefined ||
      !param.time ||
      param.point.x < 0 ||
      param.point.x > container.clientWidth ||
      param.point.y < 0 ||
      param.point.y > container.clientHeight
    ) {
      legend.style.display = "none";
      return;
    } else {
      legend.style.display = "block";
      let bar = param.seriesData.get(candleStickSeries);
      let openPrice = bar.open;
      let highPrice = bar.high;
      let lowPrice = bar.low;
      let closePrice = bar.close;
      var formatPrice = (price) => price.toFixed(4);
      let openPriceFormatted = formatPrice(openPrice);
      let highPriceFormatted = formatPrice(highPrice);
      let lowPriceFormatted = formatPrice(lowPrice);
      let closePriceFormatted = formatPrice(closePrice);

      let timestampMs = bar.time * 1000;
      let ToDate = new Date(timestampMs);
      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        hour12: false,
        timeZone: "Asia/Seoul",
      };

      let timestampToString = ToDate.toLocaleString("ko-KR", options);

      let tooltipSeries = tooltipData.find((data) => data.time == bar.time);
      // console.log(tooltipSeries);
      let entryStart, entryEnd, takeStart, takeEnd, stop;

      toolTipHeight = 180;

      if (tooltipSeries != undefined) {
        entryStart = tooltipSeries.entry_start;
        entryEnd = tooltipSeries.entry_end;
        takeStart = tooltipSeries.take_start;
        takeEnd = tooltipSeries.take_end;
        stop = tooltipSeries.stop;
        toolTipHeight = 270;
      }

      let tooltipPink, tooltipPinkVal;
      if (
        param.seriesData.get(pinkLine) != undefined &&
        toggleStatus.value["pink"]
      ) {
        tooltipPink = param.seriesData.get(pinkLine);
        tooltipPinkVal = tooltipPink.value;
      } else {
        tooltipPinkVal = undefined;
      }

      setTooltipHtml(
        ticker.value,
        timestampToString,
        openPriceFormatted,
        highPriceFormatted,
        lowPriceFormatted,
        closePriceFormatted,
        entryStart,
        entryEnd,
        takeEnd,
        takeStart,
        stop,
        tooltipPinkVal
      );

      const y = param.point.y;

      let left = param.point.x + 70;
      if (left > container.clientWidth - toolTipWidth) {
        left = param.point.x - toolTipMargin - toolTipWidth;
      }

      let top = y + toolTipMargin;
      // console.log('container.clientHeight',container.clientHeight);

      if (top > container.clientHeight - 30 - toolTipHeight) {
        top = y - toolTipHeight + toolTipMargin;
        // console.log('마우스 중간보다 밑에');
      }
      legend.style.left = left + "px";
      legend.style.top = top + "px";
      // console.log('top',top,'y',y,'toolTipHeight',toolTipHeight);
      // console.log('param.point.x',param.point.x);
    }
  };

  chart.subscribeCrosshairMove(updateLegend);

  chart.timeScale().fitContent();
  emit("mounted");
});
onUnmounted(() => {
  if (chart) {
    chart.remove();
    chart = null;
  }
});

async function getCandleData(
  candleStickSeries,
  pinkLine,
  uoSeries,
  candleType
) {
  try {
    if (candleType == "candle") {
      if (!candleLoad) {
        isFetch.value = false;
        return await axios
          .get(`${url}/candle/${candleType}?ticker=${ticker.value}`)
          .then((res) => {
            candleLoad = true;
            let candleData = res.data.result;
            // console.log("candleData", candleData);
            candleArray = [];
            pinkArray = [];
            uoArray = [];
            for (let i = 0; i < candleData.length; i++) {
              candleArray.push({
                time: candleData[i].time,
                open: Number(candleData[i].open),
                high: Number(candleData[i].high),
                low: Number(candleData[i].low),
                close: Number(candleData[i].close),
              });
              pinkArray.push({
                time: candleData[i].time,
                value: Number(candleData[i].pink),
              });
              if (candleData[i].open != "") {
                let sma5 = 0,
                  sma34 = 0,
                  indexForCalculation;

                // i가 33 미만이면 i + 33의 값을 사용하고, 아니면 i를 그대로 사용
                indexForCalculation = i < 33 ? i + 33 : i;

                // 5일 이동 평균 계산
                for (
                  let j = indexForCalculation - 4;
                  j <= indexForCalculation;
                  j++
                ) {
                  sma5 += candleData[j].open;
                }
                sma5 /= 5;

                // 34일 이동 평균 계산
                for (
                  let j = indexForCalculation - 33;
                  j <= indexForCalculation;
                  j++
                ) {
                  sma34 += candleData[j].open;
                }
                sma34 /= 34;

                let ao = sma5 - sma34;

                // i가 33 미만이면 i의 시간을 사용, 아니면 indexForCalculation의 시간을 사용
                let time =
                  i < 33
                    ? candleData[i].time
                    : candleData[indexForCalculation].time;

                uoArray.push({ time: time, value: ao });
              }
            }
            candleStickSeries.setData(candleArray);
            pinkLine.setData(pinkArray);
            uoSeries.setData(uoArray);
            isFetch.value = true;
          });
      }
    } else {
      if (!candleHeiLoad) {
        isFetch.value = false;
        return await axios
          .get(`${url}/candle/${candleType}?ticker=${ticker.value}`)
          .then((res) => {
            candleHeiLoad = true;
            let candleData = res.data.result;
            // console.log("candleData", candleData);
            candleHeiArray = [];
            pinkHeiArray = [];
            uoHeiArray = [];
            for (let i = 0; i < candleData.length; i++) {
              candleHeiArray.push({
                time: candleData[i].time,
                open: Number(candleData[i].open),
                high: Number(candleData[i].high),
                low: Number(candleData[i].low),
                close: Number(candleData[i].close),
              });
              pinkHeiArray.push({
                time: candleData[i].time,
                value: Number(candleData[i].pink),
              });
              if (candleData[i].open != "") {
                let sma5 = 0,
                  sma34 = 0,
                  indexForCalculation;

                // i가 33 미만이면 i + 33의 값을 사용하고, 아니면 i를 그대로 사용
                indexForCalculation = i < 33 ? i + 33 : i;

                // 5일 이동 평균 계산
                for (
                  let j = indexForCalculation - 4;
                  j <= indexForCalculation;
                  j++
                ) {
                  sma5 += candleData[j].open;
                }
                sma5 /= 5;

                // 34일 이동 평균 계산
                for (
                  let j = indexForCalculation - 33;
                  j <= indexForCalculation;
                  j++
                ) {
                  sma34 += candleData[j].open;
                }
                sma34 /= 34;

                let ao = sma5 - sma34;

                // i가 33 미만이면 i의 시간을 사용, 아니면 indexForCalculation의 시간을 사용
                let time =
                  i < 33
                    ? candleData[i].time
                    : candleData[indexForCalculation].time;

                uoHeiArray.push({ time: time, value: ao });
              }
            }
            isFetch.value = true;
          });
      }
    }
  } catch (error) {
    // console.log("error", error);
    isFetch.value = false;
    errorRef.value = "Error occured.";
  }
}
async function getSignalMarkers(candleStickSeries) {
  try {
    return await axios
      .get(`${url}/analysis/rising-signal?ticker=${ticker.value}`)
      .then((res) => {
        signalMarkers = [];
        let result = res.data.result;
        tooltipData = result;
        // console.log("tooltip", tooltipData);
        for (let i = 0; i < result.length; i++) {
          let timestamp = result[i].time;
          // console.log("time", timestamp);
          let signal = result[i].signal;
          let position = signal == "L" ? "belowBar" : "aboveBar";
          let color =
            signal == "L"
              ? getCssVariableValue("--signal-buy")
              : getCssVariableValue("--signal-sell");
          signalMarkers.push({
            time: timestamp,
            position: position,
            color: color,
            shape: "circle",
            text: signal,
            size: 1.5,
          });
        }
        candleStickSeries.setMarkers(signalMarkers);
        // console.log(signalMarkers);
      });
  } catch (e) {
    // console.log(e);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/charts/meta.scss";
.tooltip-bg {
  position: absolute;
  display: block;
  border-style: solid;
  white-space: nowrap;
  z-index: 9999999;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 2px 10px;
  transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  background-color: rgba(1, 5, 24, 0.8);
  border-width: 1px;
  border-radius: 4px;
  color: rgb(102, 102, 102);
}
</style>
